import AddFavTile from '@atoms/AddFavTile';
import MyModal from '@atoms/MyModal';
import { Text, View } from '@components/primitives';
import AntDesign from '@expo/vector-icons/AntDesign';
import { scale } from '@utils/normalize';
import React from 'react';
import { Pressable, FlatList } from 'react-native';
import styles from './style';

interface AddFavProductsProps {
  isVisible?: boolean;
  handleVisible: () => void;
  t: (key: string) => string;
  data: any;
  onAddFavSuccess: () => void;
  show: boolean;
}

interface ProductTileProps {
  item: any;
}

const AddFavProducts: React.FC<AddFavProductsProps> = ({
  isVisible = false,
  handleVisible,
  t,
  data = [],
  onAddFavSuccess,
  show,
}) => {
  const renderProductTile = React.useCallback<React.FC<ProductTileProps>>(
    ({ item }) => (
      <AddFavTile
        bpCategoryProducts={item}
        source="home_page"
        onPressHandler={handleVisible}
        onAddFavSuccess={onAddFavSuccess}
      />
    ),
    [],
  );

  if (!show || data.length === 0) return null;

  return (
    <MyModal
      hasBackdrop
      isVisible={isVisible}
      animationIn={undefined}
      animationOut={undefined}
      onPress={handleVisible}
      statusBarTranslucent
      hideModalContentWhileAnimating
      outerContainerStyle={styles.containerStyle}>
      <View
        accessible={false}
        importantForAccessibility="yes"
        accessibilityViewIsModal
        style={styles.innerContainer}>
        <View style={styles.rowStyle}>
          <Text variant="md-bold" style={styles.centerText}>
            {t('favourites.titleSheet')}
          </Text>
          <Pressable testID="addFavClose" style={styles.crossPressable} onPress={handleVisible}>
            <AntDesign name="close" size={scale(20)} />
          </Pressable>
        </View>

        <FlatList
          scrollEnabled={false}
          testID="fltLstTopProducts"
          style={styles.topProductsList}
          contentContainerStyle={[styles.fltLstContainerStyle]}
          numColumns={4}
          data={data}
          keyExtractor={item => item?.id?.toString()}
          renderItem={({ item }) => <View style={styles.boxStyle}>{renderProductTile({ item })}</View>}
        />
      </View>
    </MyModal>
  );
};

export default AddFavProducts;
